import { NavigationProp, useNavigation } from "@react-navigation/native";
import { useCallback, useEffect } from "react";

import { ClubStackNavigatorParamList } from "../../../../navigators/ClubNavigator";

export const useHandleInvalidShareId = (
  clubSlug: string | undefined,
  hasSharedBooking: boolean
) => {
  const navigation =
    useNavigation<NavigationProp<ClubStackNavigatorParamList>>();
  const navigateHome = useCallback(() => {
    if (!!clubSlug) {
      navigation.navigate("Home", { clubSlug, screen: "MainHome" });
    }
  }, [clubSlug, navigation]);
  /**
   * If the user is logged in and there is no shared booking, navigate to the home screen
   * because this isn't a valid share ID.
   */
  useEffect(() => {
    if (clubSlug && !hasSharedBooking) {
      navigateHome();
    }
  }, [clubSlug, hasSharedBooking, navigateHome]);
};
